module.exports = __webpack_public_path__ + "img/logo_livera.ca94475e.png";